import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { useContextChatStore } from '@/lib/contextChat';

interface AuthState {
  user: any;
  token: string | null;
  isAuthenticated: boolean;
  setUser: (user: any) => void;
  setToken: (token: string | null) => void;
  logout: () => void;
  isAdmin: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setUser: (user) => {
        set({ user, isAuthenticated: !!user });
        // Бейджи обсуждений: id текущего пользователя + первичное обновление
        // счётчиков по контекстам (SSoT — contextChat)
        useContextChatStore.getState().setMyId(user?.id || '');
        if (user?.id) void useContextChatStore.getState().refresh();
      },
      setToken: (token) => set({ token }),
      logout: () => set({ user: null, token: null, isAuthenticated: false }),
      isAdmin: () => {
        const state = get();
        const roles = state.user?.roles || [];
        return roles.includes('admin') || roles.includes('global:admin');
      },
    }),
    {
      name: 'hydra-auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

// Legacy export
export const authStore = useAuthStore;
